// extracted by mini-css-extract-plugin
export default {"okBtn":"Button_okBtn__M1hDG","confirmBtn":"Button_confirmBtn__G10I5","sendBtn":"Button_sendBtn__2Etin","rejectBtn":"Button_rejectBtn__-TtuR"};